import { render, staticRenderFns } from "./ModuleManageDomain.vue?vue&type=template&id=10f569d1"
import script from "./ModuleManageDomain.vue?vue&type=script&lang=js"
export * from "./ModuleManageDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports